<template>
  <div class="home">
    <div id="nav">
      <div class="header">
        <div class="logo">
          <div class="logo-icon"></div>
          <!-- <div> -->
          <div class="logo-title" v-if="$env.domain == 'yq'">舆情监测预警系统</div>
          <div class="logo-title" v-else>群体性事件<br>监测预警系统</div>

          <!-- <div class="logo-desc">P2P lending early warning</div></div> -->
        </div>
        <ul class="tabList" @click="toPage($event)">
          <li v-if="routesEnable.includes('summary')">
            <span
              class="route route-summary"
              :class="{'active':currentRouteId===0}"
            >舆情概要</span>
          </li>
          <li v-if="routesEnable.includes('media')">
            <span
              class="route route-media"
              :class="{'active':currentRouteId===1}"
            >媒体监测</span>
          </li>
          <li v-if="routesEnable.includes('group')">
            <span
              class="route route-group"
              :class="{'active':currentRouteId===2}"
            >群组监测</span>
          </li>
          <li v-if="routesEnable.includes('focus')">
            <span
                class="route route-focus"
                :class="{'active':currentRouteId===6}"
            >重点关注</span>
          </li>
          <li v-if="routesEnable.includes('event')">
            <span
                class="route route-event"
                :class="{'active':currentRouteId===7}"
            >重点事件</span>
          </li>
          <li v-if="routesEnable.includes('warn_list')">
            <span
              class="route route-warn_list"
              :class="{'active':currentRouteId===3}"
            >预警列表</span>
          </li>
          <li v-if="routesEnable.includes('report')">
            <span
              class="route route-report"
              :class="{'active':currentRouteId===4}"
            >分析报告</span>
          </li>
          <li v-if="routesEnable.includes('job_config')">
            <span
              class="route route-job_config"
              :class="{'active':currentRouteId===5}"
            >监测配置</span>
          </li>
        </ul>
        <div class="input-wrap">
          <input
            type="text"
            v-model="keywords_search"
            maxlength="32"
            placeholder="请输入关键词"
            class="input-search-global"
            autocomplete="off"
            id="search-keywords"
            @keyup.enter="searchByKeywords"
          />
          <div class="input-mask" v-if="!enable_search" @click="$Message.error('未获得该功能权限')"></div>
          <span class="icon-search" @click="searchByKeywords"></span>
        </div>
        <div class="avatar-wrap">
          <div class="avatar"></div>
          <div class="btn-group-wrap" ref="btnGroupPersonal">
            <div class="btn" @click.stop="toCenter">个人中心</div>
            <div class="btn" @click="handleLogout">退出登录</div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  data() {
    return {
      //搜索框输入的内容
      keywords_search: "",
      //当前激活的路由id
      currentRouteId: -1,
      //记录拥有权限的路由
      routesEnable: [],
      //权限-全局搜索
      enable_search: false
    };
  },
  created() {
    this.routesEnable = this.getLocalStorage("authorities").split(",");
    console.log('created' + this.routesEnable);
  },
  mounted() {
    this.refreshNav();
    //判断权限-全局搜索
    this.enable_search = this.routesEnable.includes("search");
  },
  methods: {
    //跳转到相关页面
    toPage(e) {
      if (e.target.tagName === "SPAN") {
        let routeClass = e.target.className;
        if (routeClass.includes("disabled")) {
          this.$Message.error("未获得该页面权限");
          return;
        }
        //获取路由名称
        let route = routeClass
          .split(" ")
          .filter(item => {
            return item.includes("route-");
          })[0]
          .split("-")[1];
        //根据路由名称跳转到对应的页面
        switch (route) {
          case "summary":
            this.currentRouteId = 0;
            this.$router.push("/home");
            break;
          case "media":
            this.currentRouteId = 1;
            this.$router.push("/mediaSpec");
            break;
          case "group":
            this.currentRouteId = 2;
            this.$router.push("/groupSpec");
            break;
          case "warn_list":
            this.currentRouteId = 3;
            this.$router.push("/warningList");
            break;
          case "report":
            this.currentRouteId = 4;
            this.$router.push("/report");
            break;
          case "job_config":
            this.currentRouteId = 5;
            this.$router.push("/specConfig");
            break;
          case "focus":
            this.currentRouteId = 6;
            this.$router.push("/focus");
            break;
          case "event":
            this.currentRouteId = 7;
            this.$router.push("/event");
            break;
          default:
            break;
        }
      }
    },
    //根据当前路由给一级菜单添加样式
    refreshNav() {
      switch (this.$route.name) {
        case "home":
          this.currentRouteId = 0;
          break;
        case "mediaSpec":
          this.currentRouteId = 1;
          break;
        case "groupSpec":
          this.currentRouteId = 2;
          break;
        case "warningList":
          this.currentRouteId = 3;
          break;
        case "report":
          this.currentRouteId = 4;
          break;
        case "specConfig":
          this.currentRouteId = 5;
          break;
        case "focus":
          this.currentRouteId = 6;
          break;
        case "event":
          this.currentRouteId = 7;
          break;
        default:
          this.currentRouteId = -1;
          break;
      }
    },
    //在搜索框敲回车或点击搜索icon
    searchByKeywords() {
      this.keywords_search = this.keywords_search.trim();
      if (this.keywords_search.length == 1) {
        this.$Message.error("输入字数过少");
        return;
      } else if (this.keywords_search.length > 30) {
        this.$Message.error("输入字数过长");
        return;
      } else if (this.keywords_search.length == 0) {
        this.$Message.error("请输入中英文字符");
        return;
      }
      let reg = /[A-Za-z0-9\u4e00-\u9fa5]/g;
      if (!reg.test(this.keywords_search)) {
        this.$Message.error("请输入中英文字符");
        return;
      }
      this.$router.push({
        path: "/searchGlobal",
        query: {
          keywords_search: this.keywords_search
        }
      });
      //跳转之后清空输入框中的内容
      this.keywords_search = "";
    },
    //点击<个人中心>按钮
    toCenter() {
      this.$router.push("personal");
      this.keywords_search = "";
    },
    //点击<退出登录按钮>
    handleLogout() {
      this.$ajax({
        method: "get",
        url: "./logout"
      })
        .then(res => {
          if (res.data.success) {
            this.$Message.success("已成功退出登录");
            window.location.reload();
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          console.log(err);
        });
    }
  },
  watch: {
    $route(to, from) {
      //一旦路由发生变化，就去更新一级菜单的样式
      this.routesEnable = this.getLocalStorage("authorities").split(",");
      this.refreshNav();
    }
  }
};
</script>

<style lang="less">
ul {
  list-style: none;
}
a {
  text-decoration: none;
}

#nav {
  background-color: #06003a;
  height: 74px;
  ::-webkit-input-placeholder {
    /* WebKit browsers */
    opacity: 0.5;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #fff;
  }

  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    opacity: 0.5;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #fff;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    opacity: 0.5;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #fff;
  }

  .header {
    margin: 0 auto;
    height: 100%;
    width: 1195px;
    display: flex;
    align-items: center;
    position: relative;
    .logo {
      // height: 35px;
      width: 170px;
      display: flex;
      align-items: center;
      line-height: 1.3;
      .logo-icon{
        background: url("https://static.rong360.com/upload/png/a9/00/a90069d295ef2134e81c6688e1af61b3.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
        width: 30px;
        height: 35px;
        margin-right: 4px;
      }
      .logo-title{
        font-size: 18px;
        font-weight: bold;
        color: white;
      }
      .logo-desc{
        color: #aeafaf;
      }

    }
    .tabList {
      // margin-left: 20px;
      user-select: none;
      li {
        float: left;
        width: 90px;
        height: 35px;
        cursor: pointer;
        .route {
          display: inline-block;
          height: 100%;
          width: 105px;
          color: #fff;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          line-height: 35px;
          text-align: center;
          cursor: pointer;
          &.active {
            border-radius: 20px;
            background-color: #415af6;
          }
          &.disabled {
            color: #999;
            cursor: not-allowed;
          }
        }
      }
    }
    .input-wrap {
      position: relative;
      .input-search-global {
        width: 221px;
        height: 36px;
        line-height: 36px;
        border-radius: 18px;
        text-indent: 2em;
        outline: none;
        border: none;
        background-color: rgba(255, 255, 255, 0.15);
        color: #fff;
        font-size: 16px;
        margin-left: 30px;
        box-sizing: border-box;
        padding-right: 38px;
      }
      .input-mask {
        position: absolute;
        z-index: 999;
        height: 100%;
        width: 221px;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.4);
        margin-left: 30px;
        cursor: not-allowed;
      }
      .icon-search {
        position: absolute;
        height: 18px;
        width: 18px;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        background: url("https://static.rong360.com/upload/png/78/f4/78f4d251dbd13c0f9ad0996591bb09f5.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
        cursor: pointer;
      }
    }
    .avatar-wrap {
      position: absolute;
      top: 0px;
      right: 0px;
      height: 74px;
      width: 150px;
      &:hover {
        .btn-group-wrap {
          display: block;
        }
      }
      .avatar {
        height: 40px;
        width: 40px;
        position: absolute;
        left: 50%;
        top: 15px;
        transform: translateX(-50%);
        border-radius: 50%;
        background: url("https://static.rong360.com/upload/png/e7/db/e7db4b9362b7f59b90fc7580ca1a1d75.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
      }
      .btn-group-wrap {
        display: none;
        position: absolute;
        right: 0;
        top: 74px;
        transform: translateZ(100px);
        z-index: 999;
        width: 150px;
        height: 80px;
        background-color: #06003a;
        &:hover {
          display: block;
        }
        .btn {
          height: 40px;
          line-height: 40px;
          color: #fff;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.2s ease;
          &:hover {
            background-color: #4169e1;
          }
        }
      }
    }
  }
  .content {
    overflow: auto;
  }
}
</style>

